import React, { Component } from 'react'
import Parallax from 'parallax-js'
import './Hero.scss'
import Topbar from '../../Common/Topbar'
import Button from '../../Components/Button'
import { ReactComponent as ParallaxLayer1 } from './Assets/Layer1.svg'
import { ReactComponent as ParallaxLayer2 } from './Assets/Layer2.svg'
import { ReactComponent as ParallaxLayer3 } from './Assets/Layer3.svg'
import { Link } from 'react-router-dom'

export default class Hero extends Component {
    constructor(props) {
        super(props)

        this.state = {

        }
    }

    componentDidMount() {
        this.enableParallax();
    }

    enableParallax = () => {
        this.parallax = new Parallax(this.scene)
    }

    componentWillUnmount() {
        this.disableParallax();
    }

    disableParallax = () => {
        this.parallax.disable()
    }

    render() {
        return (
            <section className="hero">
                <Topbar type={'fixed-over'} />
                <main>
                    <h1>Welcome to iCurious, Start Exploring Now!</h1>
                    <h3>Supercharge you brain with amazing study material and students forums all in one place.</h3>

                    <div className="ctacontainer">
                        <Button variant='secondary'>Know More</Button>
                        <Link to='/discussion'>
                            <Button style={{ height: '100%' }} variant='primary'>Discussion</Button>
                        </Link>
                    </div>

                    <div className="scene" ref={e => this.scene = e}>
                        <ParallaxLayer3 className="layer bg-img-3" data-depth="0.2" />
                        <ParallaxLayer2 className="layer bg-img-2" data-depth="0.5" />
                        <ParallaxLayer1 className="layer bg-img-1" data-depth="0.3" />
                    </div>
                </main>
            </section>
        )
    }
}
